"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Data transfer object for prices history which calculated index of price change.
 *
 * @author RV
 */


var CompetitorPriceHistoryIndexDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorPriceHistoryIndexDTO, _DomainObject_1$Domai);

  function CompetitorPriceHistoryIndexDTO(competitorPriceId, priceChangeIndex) {
    var _this;

    _classCallCheck(this, CompetitorPriceHistoryIndexDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceHistoryIndexDTO).call(this));
    _this.competitorPriceId = competitorPriceId;
    _this.priceChangeIndex = priceChangeIndex;
    return _this;
  }

  return CompetitorPriceHistoryIndexDTO;
}(DomainObject_1.DomainObject);

exports.CompetitorPriceHistoryIndexDTO = CompetitorPriceHistoryIndexDTO;

CompetitorPriceHistoryIndexDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorPriceHistoryIndexDTO.name);
  return {
    competitorPriceId: builder.str('competitorPriceId'),
    priceChangeIndex: builder.opt(builder.bigNum('priceChangeIndex'))
  };
}();